import Logo from "./Logo";
import { footerLinks, professional, professionalInfo } from "@/config/professional";

export default function Footer() {
  const infoEntries = [
    { label: "Conselho profissional", value: professionalInfo.council },
    { label: "Endereço", value: professionalInfo.address },
    { label: "Cidade", value: professionalInfo.city },
    { label: "Telefone", value: professionalInfo.phone },
    { label: "E-mail", value: professionalInfo.email },
  ].filter((e) => e.value.trim() !== "");

  const hasInfo = infoEntries.length > 0;

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-3">
          {/* Brand */}
          <div>
            <Logo variant="dark" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-600">
              {professional.brandEssence}
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={professional.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-instagram-line text-lg" aria-hidden="true"></i>
              </a>
              <a
                href={professional.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-foreground-500">
              Navegação
            </h4>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Professional info */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-foreground-500">
              Informações profissionais
            </h4>
            {hasInfo ? (
              <ul className="mt-5 space-y-3">
                {infoEntries.map((entry) => (
                  <li key={entry.label} className="text-sm text-foreground-700">
                    <span className="font-semibold text-foreground-900">
                      {entry.label}:
                    </span>{" "}
                    {entry.value}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="mt-5 text-sm text-foreground-500">
                Informações de registro e contato serão adicionadas em breve.
              </p>
            )}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-8 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 Tatiana Andrade. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a
              href="#"
              className="text-xs text-foreground-500 transition-colors hover:text-primary-600"
            >
              Política de Privacidade
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 transition-colors hover:text-primary-600"
            >
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}